import Cookies from 'js-cookie'

const TokenKey = 'ahxmgk-manage-acc-dian-' + process.env.VUE_APP_Q


export function getAcc() {
  let acc = localStorage.getItem(TokenKey)
  if(acc)return JSON.parse(acc)
  return {}
}

export function setAcc(token) {
  return localStorage.setItem(TokenKey, JSON.stringify(token))
}

export function removeAcc() {
  return localStorage.removeItem(TokenKey)
}